import { ActionIcon, Badge, Group, Paper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { Integration } from "../models/agencyUser"
import { IntegrationTypeMap } from "../models/agencyUser"

interface Props {
  integration: Integration
  onDelete: (integration: Integration) => void
}

const INTEGRATION_ICONS: Record<number, string> = {
  1: "\u{1F310}",
  2: "\u{1F393}",
  3: "\u{1F30D}",
  4: "\u{1F50D}",
  5: "\u{2699}\u{FE0F}",
  6: "\u{1F4C8}",
  9: "\u{2708}\u{FE0F}",
  10: "\u{1F4CA}",
  11: "\u{1F4E6}",
  12: "\u{1F4F1}",
  13: "\u{1F3E0}",
  14: "\u{1F4B0}",
} satisfies Record<number, string>

export default function IntegrationCard({
  integration,
  onDelete,
}: Props) {
  const { t } = useTranslation()
  const icon = INTEGRATION_ICONS[integration.type] ?? "\u{1F517}"

  return (
    <Paper withBorder p="sm" radius="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Group gap="sm" align="flex-start" wrap="nowrap">
          <Text size="xl" style={{ lineHeight: 1 }}>
            {icon}
          </Text>
          <div>
            <Group gap="xs" mb={2}>
              <Text fw={600} size="sm">
                {IntegrationTypeMap[integration.type] ??
                  integration.type_name}
              </Text>
              <Badge
                color={integration.enabled ? "green" : "red"}
                variant="light"
                size="sm"
              >
                {integration.enabled
                  ? t("agencyUsers.integrationEnabled")
                  : t("agencyUsers.integrationNotEnabled")}
              </Badge>
            </Group>
          </div>
        </Group>

        <ActionIcon
          variant="subtle"
          color="red"
          size="sm"
          onClick={() => onDelete(integration)}
        >
          <i className="fa fa-trash" style={{ fontSize: 12 }} />
        </ActionIcon>
      </Group>
    </Paper>
  )
}
